import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import View from '../../components/View/View';
import Navbar from '../../components/View/Navbar/Navbar';
import NavbarLeft from '../../components/View/Navbar/NavbarLeft/NavbarLeft';
import NavbarRight from '../../components/View/Navbar/NavbarRight/NavbarRight';
import NavbarTitle from '../../components/View/Navbar/NavbarTitle/NavbarTitle';
import DrawerToggler from '../../components/View/SideDrawer/DrawerToggler/DrawerToggler';
import Page from '../../components/View/Page/Page';
import PageContent from '../../components/View/PageContent/PageContent';

import { getHelpGuides } from './helpGuides';
import styles from './Help.module.css';

class Help extends Component {
  state = { showSideDrawer: false };

  sideDrawerClosedHandler = () => this.setState({ showSideDrawer: false });
  sideDrawerTogglerHandler = () =>
    this.setState(prev => ({ showSideDrawer: !prev.showSideDrawer }));

  componentDidMount() {
    this.scrollToHash();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.hash !== this.props.location.hash) {
      this.scrollToHash();
    }
  }

  scrollToHash = () => {
    const { hash } = this.props.location;
    if (!hash) return;
    const id = hash.replace('#', '');
    // Defer to next tick so images have laid out and offsets are stable.
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  };

  render() {
    const guides = getHelpGuides();

    return (
      <View
        showSideDrawer={this.state.showSideDrawer}
        sideDrawerClosedHandler={this.sideDrawerClosedHandler}
      >
        <Navbar>
          <NavbarLeft>
            <DrawerToggler clicked={this.sideDrawerTogglerHandler} />
          </NavbarLeft>
          <NavbarTitle title="Help" leftOffset />
          <NavbarRight />
        </Navbar>
        <Page>
          <PageContent withNavbar>
            <div className={styles.Help}>
              <p className={styles.Intro}>
                Quick how-tos for the systems you use as an SSG member.
              </p>

              {guides.length > 1 && (
                <nav className={styles.TOC} aria-label="Help guides">
                  {guides.map(guide => (
                    <a key={guide.id} href={`#${guide.id}`} className={styles.TOCItem}>
                      <span className={styles.TOCCategory}>{guide.category}</span>
                      <span className={styles.TOCTitle}>{guide.title}</span>
                    </a>
                  ))}
                </nav>
              )}

              {guides.map(guide => (
                <section
                  key={guide.id}
                  id={guide.id}
                  className={styles.Guide}
                >
                  <p className={styles.Category}>{guide.category}</p>
                  <h2 className={styles.Title}>{guide.title}</h2>
                  {guide.intro && (
                    <p className={styles.GuideIntro}>{guide.intro}</p>
                  )}

                  {guide.image && (
                    <img
                      src={guide.image.src}
                      alt={guide.image.alt}
                      className={styles.Image}
                    />
                  )}

                  {guide.steps && (
                    <ol className={styles.Steps}>
                      {guide.steps.map((step, i) => (
                        <li key={i} className={styles.Step}>
                          <p className={styles.StepTitle}>{step.title}</p>
                          {step.body && (
                            <p className={styles.StepBody}>{step.body}</p>
                          )}
                        </li>
                      ))}
                    </ol>
                  )}
                </section>
              ))}
            </div>
          </PageContent>
        </Page>
      </View>
    );
  }
}

export default withRouter(Help);
